import { useState } from 'react';
import { ChevronDown, ChevronUp, Settings2 } from 'lucide-react';
import { IntegrationStatusWidget } from './integrations/IntegrationStatusWidget';
import { DataSharingSettings } from './integrations/DataSharingSettings';
import { DataSourceSettings } from './integrations/DataSourceSettings';
import { BankIntegration } from './integrations/BankIntegration';
import { EInvoiceIntegration } from './integrations/EInvoiceIntegration';
import { TaxIntegration } from './integrations/TaxIntegration';
import { PortfolioIntegration } from './integrations/PortfolioIntegration';

export function IntegrationSettings() {
  const [showAdvanced, setShowAdvanced] = useState(false);

  return (
    <div className="space-y-6">
      {/* Vue d'ensemble du statut de toutes les intégrations */}
      <IntegrationStatusWidget />

      {/* Intégration bancaire — section principale */}
      <BankIntegration />

      {/* Partage de données — toujours visible */}
      <DataSharingSettings />

      {/* Séparateur + bouton Intégration avancée (style Auth0) */}
      <div className="border-t border-border pt-2">
        <button
          type="button"
          onClick={() => setShowAdvanced(prev => !prev)}
          className="flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors select-none group"
          aria-expanded={showAdvanced}
        >
          <Settings2 className="h-4 w-4 flex-shrink-0 text-primary" />
          <span>Intégration avancée</span>
          {showAdvanced
            ? <ChevronUp className="h-4 w-4 ml-1 transition-transform" />
            : <ChevronDown className="h-4 w-4 ml-1 transition-transform" />
          }
        </button>

        {showAdvanced && (
          <div className="mt-6 space-y-6">
            {/* Sources de données et intégrations financières */}
            <DataSourceSettings />

            {/* Intégrations financières avancées */}
            <EInvoiceIntegration />
            <TaxIntegration />
            <PortfolioIntegration />
          </div>
        )}
      </div>
    </div>
  );
}